import { useEffect, useState } from "react";
import api from "@/api/client";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";

export default function CourierSelect({ value, onChange, testid = "courier-select" }) {
  const [couriers, setCouriers] = useState([]);
  useEffect(() => { api.get("/couriers").then(r => setCouriers(r.data)); }, []);
  return (
    <Select value={value || ""} onValueChange={onChange}>
      <SelectTrigger data-testid={testid} className="rounded-md border-input focus:ring-primary mt-1 font-mono">
        <SelectValue placeholder="Choose courier" />
      </SelectTrigger>
      <SelectContent className="rounded-md">
        {couriers.map(c => <SelectItem key={c} value={c}>{c}</SelectItem>)}
      </SelectContent>
    </Select>
  );
}
